var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"RkmModal",attrs:{"extraLarge":"","title":"Histórico gestante","buttons":['cancel']}},[_c('rkm-table',{attrs:{"fields":_vm.fields,"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }